import React from "react";
import { FormattedMessage } from "react-intl";
import config from "config/website";

const userAccountFooterLinks = {
  title: (
    <FormattedMessage
      id="layouts.Footer.footerLinkLists.shoppingOnline"
      defaultMessage="Shopping online"
    />
  ),
  links: [
    {
      path: "/user/orders",
      name: (
        <FormattedMessage
          id="layouts.Footer.footerLinkLists.orders"
          defaultMessage="Order Status"
        />
      ),
    },
    {
      path: "/orders",
      name: (
        <FormattedMessage
          id="layouts.Footer.footerLinkLists.guestOrders"
          defaultMessage="Guest Orders Status"
        />
      ),
    },
    {
      path: "/user",
      name: (
        <FormattedMessage
          id="layouts.Footer.footerLinkLists.account"
          defaultMessage="Account"
        />
      ),
    },
  ],
};
const contactFooterLinks = {
  title: (
    <FormattedMessage
      id="layouts.Footer.footerLinkLists.contact"
      defaultMessage="Contact"
    />
  ),
  links: [
    {
      name: (
        <FormattedMessage
          id="layouts.Footer.footerLinkLists.contactUs"
          defaultMessage="Contact us"
        />
      ),
      path: "/contact",
    },
    {
      name: (
        <FormattedMessage
          id="layouts.Footer.footerLinkLists.email"
          defaultMessage="{email}"
          values={{ email: config.email }}
        />
      ),
      path: `mailto:${config.email}`,
    },
    {
      name: (
        <FormattedMessage
          id="layouts.Footer.footerLinkLists.tel"
          defaultMessage="Phone: {phone}"
          values={{ phone: config.phoneNumber }}
        />
      ),
      path: `tel:${config.phoneNumber}`,
    },
  ],
};

export { contactFooterLinks, userAccountFooterLinks };
